// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { function16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-function': IconFunction;
    }
}

/**
 * The icon component for the 'function' icon
 */
export class IconFunction extends IconSvg {
    public constructor() {
        super(function16X16);
    }
}

registerIconSvg('icon-function', IconFunction);
export const iconFunctionTag = 'nimble-icon-function';
